"use strict";

import Page from "./Venues.jsx";

export const auth = true;
export const title = "i18n:venues.pageTitle";
export const Component = Page;
